import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

import { defaultClient as apolloClient } from "./main";
import { GET_CATEGORIES } from './graphql/Categories';
import { GET_COUNTRIES } from './graphql/Countries';
import { GET_SEARCH_COOKS, ADD_COOK, GET_COOKS, DELETE_COOK, INFINITE_SCROLL_COOKS, UPDATE_COOK, GET_COOKS_BY_INGREDIENTS } from './graphql/Cooks';
import { SIGNIN_USER, SIGNUP_USER, GET_CURRENT_USER } from './graphql/Users';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    categories: [],
    countries: [],
    cooks: [],
    searchResults: [],
    selectedCook: null,
    selectedIngredients: [],
    cooksByIngredients: null,
    user: null,
    loading: false,
    error: null,
    successMessage: null,
    authError: null
  },
  mutations: {
    setCategories: (state, payload) => {
      state.categories = payload
    },
    setCountries: (state, payload) => {
      state.countries = payload
    },
    setCooks: (state, payload) => {
      state.cooks = payload
    },
    setSearchResults: (state, payload) => {
      state.searchResults = payload
    },
    setselectedCook: (state, payload) => {
      state.selectedCook = payload
    },
    setselectedIngredients: (state, payload) => {
      state.selectedIngredients = payload
    },
    setCooksByIngredients: (state, payload) => {
      state.cooksByIngredients = payload
    },
    setUser: (state, payload) => {
        state.user = payload
    },
    setLoading: (state, payload) => {
      state.loading = payload
    },
    setError: (state, payload) => {
      state.error = payload
    },
    setSuccessMessage: (state, payload) => {
      state.successMessage = payload
    },
    setAuthError: (state, payload) => {
      state.authError = payload
    },
    clearUser: state => (state.user = null),
    clearError: state => (state.error = null)
  },
  actions: {
    getCategories: ({commit}) => {
      apolloClient
      .query({
          query: GET_CATEGORIES
      }).then(({data}) => {
        commit('setCategories', data.categories.map(c=> (c.name)))
      })
      .catch(err => {
        console.log(err)
      })
    },
    getCountries: ({commit}) => {
      apolloClient
      .query({
          query: GET_COUNTRIES
      }).then(({data}) => {
        commit('setCountries', data.countries.map(c=> (c.name)))
      })
      .catch(err => {
        console.log(err)
      })
    },
    getCurrentUser: ({commit}) => {
      commit('setLoading', true)
      apolloClient.query({
        query: GET_CURRENT_USER
      })
      .then(({data}) => {
        commit('setLoading', false)
        commit('setUser', data.me)
      })
      .catch(err => {
        commit('setLoading', false)
        localStorage.setItem('token', '')
      })
    },
    getCooks: ({commit}) => {
      commit('setLoading', true)
      apolloClient
      .query({
          query: GET_COOKS

      }).then(({data}) => {
        const idx = Math.floor(Math.random() * data.cooks.length);
        const selectedCook = data.cooks[idx]

        commit('setCooks', data.cooks)
        commit('setselectedCook', selectedCook)
        commit('setLoading', false)
      })
      .catch(err => {
        commit('setLoading', false)
        //console.log(err)
      })
    },
    searchCooks: ({commit}, payload) => {
      commit('setLoading', true)
      
      apolloClient
      .query({
          query: GET_SEARCH_COOKS,
          variables: payload
      }).then(({data}) => {  
          commit('setSearchResults', data.cooks)
          commit('setLoading', false) 
          router.push('/search')     
      })
      .catch(err => {
        commit('setLoading', false)
        commit('setError', err)
      })
    },
    addCook: ({commit}, payload) => {
      apolloClient
      .mutate({
        mutation: ADD_COOK,
        variables: payload,
        update: (cache, {data: {createCook}}) => {
          //First read the query you want to update

          const data = cache.readQuery({ query: INFINITE_SCROLL_COOKS, variables: {pageNum: 1, pageSize: 9} })

          // Create updated data
          data.infinteScrollCooks.cooks.unshift(createCook)
          // Write updated data back to the query
          cache.writeQuery({
            query: INFINITE_SCROLL_COOKS,
            variables: {pageNum: 1, pageSize: 9},
            data
          })
        },
        // Ensures data is added immediately
        
        optimisticResponse: {
          __typename: 'Mutation',
          createCook: {
            __typename: 'Cook',
            ...payload
          }
        }
        
      }).then(({data}) => {
        let message = 'تم إضافة الطبخة بنجاح'
        commit('setSuccessMessage', message)
        router.push('/cooks')       
        return data
      })
      .catch(err => {
        let error = 'لم تتم إضافة الطبخة, حاول مرة أخرى'
        commit('setError', error)
        console.log(err)
      })
    },
    updateCook: ({commit}, payload) => {
      apolloClient
      .mutate({
        mutation: UPDATE_COOK,
        variables: payload,
        update: (cache, {data: {updateCook}}) => {
          //First read the query you want to update

          const data = cache.readQuery({ query: INFINITE_SCROLL_COOKS, variables: {pageNum: 1, pageSize: 9} })

          let index = data.infinteScrollCooks.cooks.findIndex(cook => cook.id === updateCook.id) 

          let updatedCooks = [
            ...data.infinteScrollCooks.cooks.slice(0, index),
            updateCook,
            ...data.infinteScrollCooks.cooks.slice(index + 1)
          ]
          // Write updated data back to the query
          cache.writeQuery({
            query: INFINITE_SCROLL_COOKS,
            variables: {pageNum: 1, pageSize: 9},
            data: updatedCooks
          })
        }
        
      }).then(({data}) => {
        let message = 'تم تعديل الطبخة بنجاح'
        commit('setSuccessMessage', message)
        router.push('/cooks')       
        return data
      })
      .catch(err => {
        let error = 'لم يتم تعديل الطبخة, حاول مرة أخرى'
        commit('setError', error)
        console.log(err)
      })
    },
    deleteCook: ({state, commit}, payload) => {
      apolloClient
      .mutate({
        mutation: DELETE_COOK,
        variables: {id: payload},
        update: (cache, {data: {deleteCook}}) => {
          //First read the query you want to update

          const data = cache.readQuery({ query: INFINITE_SCROLL_COOKS, variables: {pageNum: 1, pageSize: 9} })

          // Create updated data
          data.infinteScrollCooks.cooks = data.infinteScrollCooks.cooks.filter(cook => cook.id !== deleteCook.id) 
          // Write updated data back to the query
          cache.writeQuery({
            query: INFINITE_SCROLL_COOKS,
            variables: {pageNum: 1, pageSize: 9},
            data
          })
        }
      }).then(({data}) => { 
        let message = 'تم حذف الطبخة بنجاح'
        commit('setSuccessMessage', message)      
        return data
      })
      .catch(err => {
        let error = 'خطأ عند حذف الطبخة, حاول مرة أخرى'
        commit('setError', error)
        console.log(err)
      })
    },
    signin: ({commit}, payload) => {
      commit('clearError')
      commit('setLoading', true)
      
      apolloClient
      .mutate({
        mutation: SIGNIN_USER,
        variables: payload
      })
      .then(({data}) => {
        commit('setLoading', false)
        localStorage.setItem('token', data.signin.token)
        //To make sure created method is run is main.js (we run getCurrentUser),
        // reload the page
        router.go()
      })
      .catch(err => {
        commit('setLoading', false)
        let error = 'يوجد خطأ, يرجى إعادة المحاولة'
        commit('setError', error)
      })
    },
    signup: ({commit}, payload) => {
      commit('clearError')
      commit('setLoading', true)
      
      apolloClient
      .mutate({
        mutation: SIGNUP_USER,
        variables: payload
      })
      .then(({data}) => {
        commit('setLoading', false)
        localStorage.setItem('token', data.signup.token)
        //To make sure created method is run is main.js (we run getCurrentUser),
        // reload the page
        router.go()
      })
      .catch(err => {
        commit('setLoading', false)
        commit('setError', err)
      })
    },
    signout: async ({commit}) => {
      // Clear user in state

      commit('clearUser')
      // Remove token in localstorage
      localStorage.setItem('token', '')
      // end session
      await apolloClient.resetStore()
      // redirect home
      router.push('/')
    },
    selectByIngrdients: ({commit}, payload) => {
      commit('setLoading', true)
      commit('setselectedIngredients', payload)
      
      apolloClient
      .query({
          query: GET_COOKS_BY_INGREDIENTS,
          variables: {ingredients: payload},

      }).then(({data}) => {
          commit('setCooksByIngredients', data.cooksByIngredients) 
          commit('setLoading', false)
          router.push('ByIngredients')        
      })
      .catch(err => {
        commit('setLoading', false)
        console.log(err)
      })
    }

  },
  getters: {
    categories: state => state.categories,
    countries: state => state.countries,
    cooks: state => state.cooks,
    searchResults: state => state.searchResults,
    selectedCook: state => state.selectedCook,
    selectedIngredients: state => state.selectedIngredients,
    cooksByIngredients: state => state.cooksByIngredients,
    loading: state => state.loading,
    user: state => state.user,
    error: state => state.error,
    successMessage: state => state.successMessage,
    authError: state => state.authError
  }
})
